import React, { useState, useEffect } from "react";
import PAsidePanel from "../PAsidePanel";
import styled, { css } from "styled-components";
import PAvcNew from "./PAvcNew";
import { vc } from "../../data/vc";
import { CssTable, CssViZ, PAviItemLine } from "../ingame/PAviGroup";

import {Table, Breadcrumbs, CssCounter, Button, Dropdown, FormGroup, Icon, Input, Pill, Select, StatusDot } from "xsolla-uikit";
import { PAinfoCollapsible, CssVCimage, CssVCimages } from '../uikit2'
import PAh2 from '../PAh2';
import { Link } from "react-router-dom";
export default function PAvcPacks({

  packs = [],
  currency,
  products,
  appearance,
  opened = false,
  order = 1,
  id = 159428,
  sku = "gun_1",
  localized_name = "Xsolla Basic Blaster 1",
  prices = {
    USD: 1.99
  },
  virtual_currency_price = null,
  default_currency = "USD",
  enabled = true,
  permanent = false,
  image_url = "//cdn3.xsolla.com/img/misc/images/0c59a7698d4f66c1008b27ee752089b7.png",
  advertisement_type = null
}) {
  const [active, setActive] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let tim;
    if (active !== false) {
      if (!open) {
        tim = setTimeout(() => {
          setOpen(true);
        }, 100);
      }
    }
    else {
      setOpen(false);
    }
    return (() => {
      if (typeof tim !== 'undefined')
        clearTimeout(tim);
    });
  }, [active]);


console.log('vc = ', vc);





  const columns = [
      // {
      //   width: '7%',
      //   id: 'Order',
      //   name: 'Order',
      //   sticky: true,
      //   fieldGetter: (rw)=> {
      //     let i = 0
      //     vc.forEach((oneV, ind) => {
      //       if (oneV['id'] === rw['id']) i = ind;
      //     })
      //     return (<div className="">
      //       <div class="ui-table__drag-handle"></div>
      //     <div
      //       style={{display: 'flex', justifyContent:'center'}}
      //       >{i + 1}</div>
      //     </div>);
      //   }
      // },


      {
        width: '20%',
        id: 'Name',
        name: 'Package name and description',
        fieldGetter: (rw)=> {
          return   (
            <div className="l_flex">
              <CssVCimages
              // image_url={getCurrencyData(rw['sku'])}
              image_url={image_url}
              amount={rw['amount']}
              />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <div className="">
                <b>{rw['description']['en']}</b><br/>
                {rw['label']}
              </div>
            </div>

          )
        }
      },

      {
        width: '10%',
        id: 'Amount',
        name: 'Amount',
        fieldGetter: (rw)=><strong>{rw['amount']}</strong>
      },

      {
        width: '10%',
        id: 'bonus',
        name: 'Bonus',
        fieldGetter: 'bonus'
      },
      {
        width: '10%',
        id: 'priceOld',
        name: 'Original price',
        fieldGetter: (rw) => `${rw['prices_array'][0]['name']} ${rw['prices_array'][0]['value']}`
      },
      {
        width: '10%',
        id: 'price',
        name: 'Pack price',
        fieldGetter: (rw) => {
          let newPrice = rw['prices_array'][0]['value'] - (Math.round(rw['prices_array'][0]['value']*rw['bonus']))
          return <strong>{`${rw['prices_array'][0]['name']} ${newPrice}`}</strong>
        }
      },
      {
        width: '5%',
        id: 'Name',
        name: '',
        fieldGetter: ()=><Dropdown
        align="right"
        autosize={true}
        separated={false}
        options={[
          {label: 'Settings', icon: 'settings'},
          {label: 'Delete', color: '#eb002f', icon: 'delete'}
        ]}>
        <Icon name="more" />
      </Dropdown>
      },

    ];



const rows = [{
    id: 1
  }];








  return (<FormGroup>
    <CssTable100 open={open}
      style={{width: '100%'}}
    >
      <div>
      <PAsidePanel
          z={false}
          isOpen={active !== false ? true : false}
          handleClose={() => setActive(false)}
          header={localized_name}
        >

        </PAsidePanel>



      <PAinfoCollapsible
        isOpen={packs.length ? true : false}
        title="Currency packages"
        counter={packs.length}
        // title="titlll"
        extra={<Link to="/microtransactions/new_currency"><Button appearance="flatten"><Icon name="circle-plus" size={24}/>&nbsp;&nbsp;Create package&nbsp;</Button></Link>}
      >
        <div className="ui-table" style={{
          // position: "relative", overflow: 'hidden'
        }}>

<PAvcTable
columns={columns}
packs={packs}
/>

        </div>
      </PAinfoCollapsible>


      </div>
    </CssTable100>
  </FormGroup>
  );
}



export function PAvcTable ({columns, packs}) {
  return(
    <Table
            compact={true}
            renderEmptyMessage = {()=><div>
              <FormGroup>
                <Link to="/microtransactions/new_currency"><Button appearance="outline-secondary">Create package</Button></Link>
              </FormGroup>
            </div>}
            style={{width: '100%'}}
            horizontalScroll={true}
            columns={columns}
            rows={packs}
          />
  )
}



const CssTable100 = styled.div`
  border: none;
  overflow: visible;
  padding-bottom: 16px;
  & .ui-table {
    overflow: visible;
    margin: 0 -16px -12px;
  }
  & .xsui-table-head-cell {
    background: transparent;
  }
`;